import styled from 'styled-components';

export const StyledOSTagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
  justify-content: center;
`;
